import { useRef } from 'react';

/**
 * Browse button that only captures the selected filename (no file upload/read).
 */
export default function FileBrowseField({
  label,
  value = '',
  onChange,
  accept = '.geojson,.gpkg,.shp,.tif,.tiff,.zip',
}) {
  const inputRef = useRef(null);

  function handlePick(event) {
    const file = event.target.files?.[0];
    if (file) {
      onChange(file.name);
    }
    event.target.value = '';
  }

  return (
    <label className="form-field file-browse-field">
      <span>{label}</span>
      <div className="file-browse-row">
        <input
          type="text"
          readOnly
          value={value || ''}
          placeholder="No file selected"
          title={value || 'No file selected'}
        />
        <button
          type="button"
          className="btn btn-outline btn-sm"
          onClick={() => inputRef.current?.click()}
        >
          Browse…
        </button>
        {value ? (
          <button
            type="button"
            className="btn btn-link btn-sm"
            onClick={() => onChange('')}
          >
            Clear
          </button>
        ) : null}
      </div>
      <input
        ref={inputRef}
        type="file"
        className="sr-only"
        accept={accept}
        onChange={handlePick}
        tabIndex={-1}
      />
      <span className="field-hint">Demo only — the filename is shown; no data is uploaded or read.</span>
    </label>
  );
}
